import { required } from "vuelidate/lib/validators";

const stockEntityDefaultFields = {
  name: {
    required,
  },
  type: {
    required,
  },
  barcode: {
    required,
  },
  vendor_code: {
    required,
  },
};

const schemas = {
  project: {
    name: {
      required,
    },
    user_id: {
      required,
    },
    products_data: {
      required,
    },
  },
  purchaseOrder: {
    number: {
      required,
    },
    shipping_date: {
      required,
    },
  },
  product: {
    ...stockEntityDefaultFields,
    color: {
      required,
    },
    price: {
      required,
    },
    gender: {
      required,
    },
    cloth_structure: {
      required,
    },
    sizes_data: {
      required,
    },
  },
  packageItem: {
    ...stockEntityDefaultFields,
  },
  sewingAccessory: {
    ...stockEntityDefaultFields,
  },
  promotionalProduct: {
    ...stockEntityDefaultFields,
  },
  expendableMaterial: {
    ...stockEntityDefaultFields,
  },
  stationery: {
    ...stockEntityDefaultFields,
    stationery_subtype: {
      required,
    },
  },
  cloth: {
    ...stockEntityDefaultFields,
    color: {
      required,
    },
    structure: {
      required,
    },
  },
  cutOfClothes: {
    ...stockEntityDefaultFields,
  },
};

export default schemas;



// WEBPACK FOOTER //
// ./src/stock/validation-schemas/index.js